import { BatchHttpLink } from 'apollo-link-batch-http'
import clientEnv from 'utils/global/clientEnv'

export const apolloHttpLink = new BatchHttpLink({
  uri: `${clientEnv.PUBLIC_CLIENT_ENTERPRISE_DASHBOARD_API_URL}/graphql`,
  batchMax: 1,
})
